import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import { useUsers } from '../context/UserContext'
import { useLogin } from '../context/LoginContext'

import ContainerBox from '../components/common/ContainerBox'
import TableData from '../components/common/TableData';
import Modal from '../components/common/Modal';
import TitleBox from '../components/common/TitleBox';
import Button from '../components/common/Button';
import UsersForm from '../components/forms/UsersForm';
import { IconPlus } from '../components/icons/Icons';

const UserPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [idUser, setIdUser] = useState(null);
  const {
    modal,
    users,
    getUsers,
    getModal
  } = useUsers();
  const { user } = useLogin();
  const navigate = useNavigate()

  useEffect(() => {
    if (user !== null) {
      navigate('/usuarios')
    }
    getUsers()
  }, [user])


  const openModal = (id = null) => {
    setIsModalOpen(true);
    setIdUser(id)
    getModal()
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };


  const columns = [
    {
      header: '#',
      cell: ({ cell }) => {
        const { row } = cell;
        return <div>{row.index + 1}</div>
      }
    },
    {
      header: 'Nombres',
      accessorKey: 'first_name'
    },
    {
      header: 'Apellidos',
      accessorKey: 'last_name'
    },
    {
      header: 'Email',
      accessorKey: 'email'
    },
    {
      header: 'Acciones',
      cell: ({ cell }) => {
        const id = cell.row.original.id
        return <div className='flex items-center'>
          <button
            className="bg-warning/50 hover:bg-warning/60 border border-warning/20 text-xs text-black/50 px-3 py-1 rounded-sm"
            onClick={() => openModal(id)}
          >
            Editar
          </button>
          <button
            className="bg-danger/20 hover:bg-danger/30 border border-danger/20 text-xs text-danger px-3 py-1 rounded-sm"
            onClick={openModal}
          >
            Eliminar
          </button>
        </div>
      }
    }
  ];

  return (
    <>
      <TitleBox title='Maestro usuario de sistema' />
      <ContainerBox>
        <Button value='Nuevo' openModal={() => openModal()}>
          <IconPlus className='w-4' />
        </Button>
        <TableData columns={columns} data={users} />
      </ContainerBox>
      <Modal isOpen={isModalOpen} onClose={closeModal} isModal={modal} title={"Nuevo usuario"}>
        <UsersForm user={idUser} />
      </Modal>
    </>
  )
}

export default UserPage